import React from 'react';
import './MessageList.css';

function MessageList({ messages, isLoading, onBusinessClick, onDeepDive }) {
  return (
    <div className="message-list">
      {messages.map(message => (
        <div 
          key={message.id} 
          className={`message ${message.role} ${message.isError ? 'error' : ''}`}
        >
          <div className="message-content">
            {message.content}
          </div>
          <div className="message-time">
            {message.timestamp.toLocaleTimeString('en-CA', { 
              hour: '2-digit', 
              minute: '2-digit' 
            })}
          </div>
        </div>
      ))}
      
      {isLoading && (
        <div className="message assistant loading">
          <div className="message-content">
            <div className="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MessageList;